const RileylolAllReleasesStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/5VZmNX2MMsCG3TXkG3IunL?si=519686df46354a69" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>notamachine - broken (feat. Kawaii Ry & rileylol)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/riley-lol-the-glass-remix-prod-uglyboy" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-URk9iXyuTz2pGGQp-Ukwv1A-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>the glass *remix* *2021*</strong><br/>
                (prod. uglyboy)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/sadoutwest/yng-spike-sos-feat-sadoutwest" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-BLLGwZvI5ha0qVQH-p41GSw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Yng Spike - SOS (feat. rileylol) *2021*</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1cuRA9aXS4nFQtlLR34X8J?si=865f43cdf5014863" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-vjQ81JKb9kyLXEvS-Xk207Q-t500x500.png" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>nothing more</strong><br/>
                (prod. dead yami)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1cuRA9aXS4nFQtlLR34X8J?si=865f43cdf5014863" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02329d13e9be5a889e415ff8cd" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>petty</strong><br/>
                (prod. drecyy)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Music Video / Single</p>
            <a href="https://www.youtube.com/watch?v=lT7F5eKwxlU&feature=youtu.be" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-hrrjgNPpDzbCO7wR-7tezOw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>portland</strong><br/>
                (prod. immortal)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3ejiQdnRk1RrI7uGmyZfFM?si=1d0b20eafb0c4700" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e029e17edf9a34a73a530e9a37e" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>another life</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6snMT1m4cAviOUqR5Dyf3n?si=62b4942a44d2445a" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02a07cd096f8b879cbe1caa60c" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>time zones</strong><br/>
                (prod. grayskies)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/53NHEFALc5PzvBfIUrbMeZ?si=849e27a656004640" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e022481f3eabf8222ec51ccbe72" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>church st.</strong><br/>
                (prod. nick nash & vlex)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1S4WkFXLw4plyxvofsqmZp?si=83c48d84d77a4e0f" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-GWPhy8UbYAKL0mDz-0LkXfg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>just friends</strong><br/>
                (prod. luvdakvsh)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/36ujinTqEa7emYLSgeW7ss?si=5059e69f476e4298" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e024de4bbe8fcab4f2ac30a8605" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>size zero</strong><br/>
                (prod. yogic & diem)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/2m5E7Z01E0oMrtqxUSUYhS?si=b6cedfc1e9dc4cdd" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-nZHypsKCH9WPzk4z-44ObSQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Don't Try It (feat. rileylol)</strong><br/>
                (prod. chris6lair)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/3eD07yn0xIZCEux6CvequI?si=ad02750dffae4b97" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Twizzy (feat. rileylol)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/2m5E7Z01E0oMrtqxUSUYhS?si=b6cedfc1e9dc4cdd" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-nZHypsKCH9WPzk4z-44ObSQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Don't Try It (feat. rileylol)</strong><br/>
                (prod. chris6lair)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/3eD07yn0xIZCEux6CvequI?si=ad02750dffae4b97" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Twizzy (feat. rileylol)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/5Y3RT0cNWDm32BCFpEbCOu?si=dfd67e4cdf9f41f1" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273f2f2bf001f382b16315b7ac3" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lugosi - 40 (feat. rileylol)</strong><br/>
                (prod. gotti)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature / Music Video</p>
            <a href="https://www.youtube.com/watch?v=viEzTBEkDMw" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-5e8PhdPzzuuG8twL-xaG7Lg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Hyder Daze - idontwannaseeyou (feat. rileylol)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/iphone?in=sadoutwest/sets/next-lifetime-ep" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-zYbISggjwbSMyy6R-oQKJFQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>iPhone</strong><br/>
                (prod. wintfye, riporigin & milojensen)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/queencreek?in=sadoutwest/sets/next-lifetime-ep" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Ah5Qpv1jjYyedgA1-jzwunw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>queen creek, az</strong><br/>
                (prod. iceboi)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/youtube?in=sadoutwest/sets/next-lifetime-ep" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ITJLtW2LFSjc5610-4TlmlQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>youtube</strong><br/>
                (prod. wintfye & frozy808)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/little-town?in=sadoutwest/sets/next-lifetime-ep" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Ah5Qpv1jjYyedgA1-jzwunw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>little town</strong><br/>
                (prod. cløud & ayoley)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/one-night-stand-red-prod-spleen?in=sadoutwest/sets/next-lifetime-ep" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Ah5Qpv1jjYyedgA1-jzwunw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>one night stands (red)</strong><br/>
                (prod. spleen!)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/heart-hand-emojis?in=sadoutwest/sets/next-lifetime-ep" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Ah5Qpv1jjYyedgA1-jzwunw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>heart hand emojis</strong><br/>
                (prod. quintuple)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/blue-sofa?in=sadoutwest/sets/next-lifetime-ep" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Ah5Qpv1jjYyedgA1-jzwunw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>blue sofa (slide thru)</strong><br/>
                (prod. cløud & dxrk)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/big-pink-tractor-nick-nash" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-4XysDcExeEALcNNF-ojIJaA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>big pink tractor</strong><br/>
                (prod. nick nash)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2FmEPUZgZL4fUpcn0lcDWp?si=8c6b0d54faf04876" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-k4CFz4vdYmWQ26wD-7cFwyw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>bad intentions</strong><br/>
                (prod. luvdakvsh)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/32GUp2j2IqKRRi0IjVnQFJ?si=84680b4de8d640d0" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-PHbxQXUwK6U0ycUr-KRAhIw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>grow up</strong><br/>
                (prod. ultra64)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0e2BMSCfFgJRGEuurd7I2T?si=85948f6057d442b6" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-yFdFK8mi4Aad6e5a-zcdlEQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>infrared</strong><br/>
                (prod. hallabanz)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4s8DMVdBnZs4WfNmmPxsk8?si=f506c5855e014b03" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-eYa5vfvvplJ2n2Gy-ezAX2Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>discord (feat. Skinny Jack Lee)</strong><br/>
                (prod. starfinesse & no agony)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4Kc2QSD6FSbpvETZFkrJIb?si=ae4d85ee9e004918" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-PBvBi3DMrDyWgOHN-lyEoxA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>wrong way</strong><br/>
                (prod. quintuple, warheart & paranorma)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/14U3oMEYRKPe5Az9kDspZO?si=ac70b8d44cb14b33" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-CihzAooya87YVkyt-RtICqQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>stimulation</strong><br/>
                (prod. 9 & killguap)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0Dasxfb1Gu74HlrHX86dnh?si=02d4196056194168" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-G2qGnFnC5zdbiseC-RPnCLA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>same page</strong><br/>
                (prod. michael rose & ayoley)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0VkwCejWmRIc41DqKogJJ5?si=8205fe5643374004" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-BaKzXsNR1bhX4NXp-XQPeQg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>mentirosa</strong><br/>
                (prod. angeless & yuno)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/53YVHbLdulD2gSBquI8uPH?si=ef43b149b6e7495e" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-MB4GebC34tgSuAVz-P4aWzA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>animosity</strong><br/>
                (prod. sossa & gendo40k)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3xrOBWyRJX9ipFXy0ZrKGp?si=0d842cacb20d4007" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-gfEWAbcF5IClGAVU-W9OLUA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>hot topic</strong><br/>
                (prod. toshi & mochila)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5vYg5g6cZiKLt9hfamTOUY?si=018d25cc83c54cb8" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-nL1Gd5KNFmbFoZ7H-NAZzFg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>staring at my phone</strong><br/>
                (prod. loverace & lvnar)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Music Video</p>
            <a href="https://www.youtube.com/watch?v=a5TkVrfFQP8" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-3BgE04FkRJIu8nak-btLjMg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>spine</strong><br/>
                (prod. Jodom)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6RH8uvFZmDogfsJmqaGHrU?si=207f1d782ea041c3" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-e1zRZhqy4lPrJaEo-tjXPqg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>hermione</strong><br/>
                (prod. Jodom)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2ceqgk5AzGNa50lTP9MfEh?si=ccbfbf155fb348e8" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-e1zRZhqy4lPrJaEo-tjXPqg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>slow down</strong><br/>
                (prod. Jodom & lukrative)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6G23D7XvLVIBZscjAis8gc?si=a3e0cba945424904" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-e1zRZhqy4lPrJaEo-tjXPqg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>so what (feat. goldenuzi)</strong><br/>
                (prod. Jodom, firemane & jdolla)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/50kbHdTJywBVZSp2Mie5kL?si=c02c4b9ebed14917" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-e1zRZhqy4lPrJaEo-tjXPqg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>air force 1's</strong><br/>
                (prod. arthur)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/weight/nervous-w-benzohart-rileylol-xmichaelwarren" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Wz12ivW4gfUczeBO-42Q0cw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>lucas2k - nervous (feat. benzohart & rileylol)</strong><br/>
                (prod. xmichaelwarren)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/sameshit" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-TYniRKL0GJF9RNIe-mQrOrw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>same shit</strong><br/>
                (prod. Baredex)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/6VmpgtFI4vF52ClGLQx5VK?si=21cd2bb79c164576" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-m2uJNVg5hpzJytsP-JZByxA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>IcedOutAngels - When the World Blows Up (feat. 3miles, rileylol & Madara TBH)</strong><br/>
                (prod. Jodom)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/2rx5ydmVzkZQQGAwa68JPP?si=5d3e42aeb28e4b05" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-m2uJNVg5hpzJytsP-JZByxA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>IcedOutAngels - Fuck An Edible (feat. 3miles, toph & rileylol)</strong><br/>
                (prod. Rhine & Nick Mira)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/6U7ABtu86SSM9cJbb3K4Yt?si=fcef54db85cd499d" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-m2uJNVg5hpzJytsP-JZByxA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>IcedOutAngels - IOA Cypher (feat. 3miles, Dreoh, rileylol, CloudGTB, toph, & Jodom)</strong><br/>
                (prod. Masetheworst)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6ckjTpFs3dI8dDoGOVJd8o?si=bb8a352ebd894b4e" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ab6ZzedrbI6SSbRa-9dlrBw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>change ur mind</strong><br/>
                (prod. Jodom, mon & damon vitucci)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/madara-tn/weekend-ft-33life-sadoutwest-prod-jodom-lukrative" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-DzzNJ09rJ9EFLzce-naiQkw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Madara TBH - Weekend (feat. rileylol & 33life)</strong><br/>
                (prod. Jodom & Lukrative)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/farming-prod-baredex-rough" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-GCohzzuRruRbREMd-zELjhg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>garden</strong><br/>
                (prod. Baredex)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/nineteen-toshi-b4-final-touches" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-xLNTdLYyYSONtric-FtCUkg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>nineteen</strong><br/>
                (prod. toshi)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/madara-tn/04-stop-the-count-feat-sadoutwest-3miles-prod-dara-x-bart-how-x-synthetic" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-93Wt7LrmXh8ySxXz-kQY0CQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Madara TBH - Stop the Count (feat. rileylol & 3miles)</strong><br/>
                (prod. Madara TBH, Bart How & Synthetic)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/mileycyrus?in=sadoutwest/sets/riley-omu-eden-project-ep" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-mDh5R1HzQiuK2Tln-AOofBw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>miley cyrus (feat. omu)</strong><br/>
                (prod. toshi)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/nicotine?in=sadoutwest/sets/riley-omu-eden-project-ep" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-mDh5R1HzQiuK2Tln-AOofBw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>nicotine (feat. omu)</strong><br/>
                (prod. toshi)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/tasteit?in=sadoutwest/sets/riley-omu-eden-project-ep" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-mDh5R1HzQiuK2Tln-AOofBw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>taste it [sinner] (feat. omu)</strong><br/>
                (prod. toshi & Nick Mira)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/surface-sinner?in=sadoutwest/sets/riley-omu-eden-project-ep" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-mDh5R1HzQiuK2Tln-AOofBw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>surface [sinner] (feat. omu)</strong><br/>
                (prod. toshi & rileylol)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/weight/that-girl-w-sadoutwest" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-7uRS5SpXZlcol5ni-OxzWhw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>lucas2k - that girl (feat. rileylol)</strong><br/>
                (prod. tenfifty)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/uglyboy4/punisher-tee-w-sadoutwest-prod-uglyboy" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-qpWBQesLJJNtSR9v-zRySUw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>uglyboy - punisher tee (feat. rileylol)</strong><br/>
                (prod. uglyboy)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/hateme" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-wwd9J2xxn4ip5gwc-4M2dBg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>hate me</strong><br/>
                (prod. smxkey stunna)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/giveit2me" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-6dH9yltoyt4dzpNT-hKs2pQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>give it 2 me</strong><br/>
                (prod. smxkey stunna)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/ioasoldier" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-2sBY123QLBOMvDAq-M86J8w-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>##ioasoldier</strong><br/>
                (prod. goldenuzi & mon)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/heavenandhell" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-byfYWD9abfvwaGyU-0Opetw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>heaven&hell (feat. sifey2dope)</strong><br/>
                (prod. idly blare)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/icedoutangels/all-alone-ft-3miles-toph-sadoutwest-prod-mason-wu-tommi-oslo-masetheworst" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-qPWQWtRtLQxbqZhz-c5FGEw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>IcedOutAngels - All Alone (feat. 3miles, toph & rileylol)</strong><br/>
                (prod. Mason Wu, Tommi Oslo & Masetheworst)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/stayinla" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Vaw61pzJgwwoQPqo-M3zr8w-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Stay in LA (feat. 3miles & Madara TBH)</strong><br/>
                (prod. Jodom & Masetheworst)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/nintendoswitch" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-QirmR7snTd2nOZoK-GMsPuw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>nintendo switch</strong><br/>
                (prod. frxstbite, mon & kuru)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/dna" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-gbzqKqFFY9dHFwaX-UV1Elw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>DNA (feat. goldenuzi)</strong><br/>
                (prod. alcor)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/whyuhatin" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-g6ibzIuILzeLcLUn-VsTy7g-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>why u hatin? (feat. lucas2k)</strong><br/>
                (prod. luca malaspina)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/missmyinhibition" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Dv4PbB6HF0tVddNl-WrzpDA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>missmyinhibition *remix*</strong><br/>
                (prod. Baredex)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/toxic" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-OqucenyMHtZIryfk-vj2efA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>toxic (feat. Midwxst)</strong><br/>
                (prod. pitfall)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Music Video</p>
            <a href="https://www.youtube.com/watch?v=7YjcSy1XSxA" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-4x3XD2BzE0yQf6y4-rzuYAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>how u doing?</strong><br/>
                (prod. quimmine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/crush-u" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-QwF33prWNzpZRqp5-GJVPWQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>crush u</strong><br/>
                (prod. blackwinterwells)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/thenight" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-pvLyHQxxdht2TdtZ-ReIS4Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>thru the night</strong><br/>
                (prod. damon vitucci & kuru)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/icedoutangels/sadoutwest-now-prod-arthur" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-xfYn7goJssQWJ6yD-RmrZYw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>now</strong><br/>
                (prod. arthur)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/caswhale/wangs-ft-sadoutwest-prod-tommi-oslo-x-nxah" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-yvAy5K1mzZJ3s2G9-jxVdiw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>caswhale - Wangs (feat. rileylol & Malachai)</strong><br/>
                (prod. tommi oslo & nxah)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/saudade-prod-theo-zim" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-L6Ooo33XFetiRAcv-yQi3NQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>saudade</strong><br/>
                (prod. theo zim)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/ac130" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-lVZnfNsKZyk6wlMR-A7q4eg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>AC - 130</strong><br/>
                (prod. kurtains)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Set</p>
            <a href="https://soundcloud.com/sadoutwest/krypzvania-set" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-23J13sRZxdwwDPkW-1RUoIw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>rileylol @ KRYPZVANIA (Full Set)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/clairvoyant" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-HhUMV79MVYyzsB5S-1qXVrg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>The Story So Far - Clairvoyant</strong><br/>
                (Rileylol Cover)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/onehundred" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-iDyxg76At0uso6mk-gjGE1Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>100</strong><br/>
                (prod. toren berios & yung tayo)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/fuckedup" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-gmZQwTDzhZRNDfwd-ePJ2bg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>fucked up</strong><br/>
                (prod. mahoney)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/spaceship" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-2WyfJXVpJKOyUngY-gG0sbA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>spaceship</strong><br/>
                (prod. jetskiii)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/weight/pieces-feat-sadoutwest-malachai-yung-cris" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-XKr0rZNUqckQ4eMw-mWC63w-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>lucas2k - Pieces (feat. rileylol & Malachai)</strong><br/>
                (prod. Yung Cris)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/weight/plastic-feat-sadoutwest-curtains" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-XKr0rZNUqckQ4eMw-mWC63w-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>lucas2k - Plastic (feat. rileylol)</strong><br/>
                (prod. Curtains)
              </p>
            </a>
          </div>  

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/eighteen-prod-mochila" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-UFfz9JI8v6PJ2cmr-TylGEQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>eighteen!</strong><br/>
                (prod. mochila)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/make-u-sick" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-qMz9p5xKhlXraEPh-4qlYgw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>make u sick!</strong><br/>
                (prod. quali)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/macbook-prod-nejdos" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-hxXA7lZG9hZqbwjv-oCqtkQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>macbook</strong><br/>
                (prod. nejdos)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single / Music Video</p>
            <a href="https://www.youtube.com/watch?v=igBUEgE6bQA" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-2FLBE4DkdEypkGte-2OjLHg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>lost freestyle</strong><br/>
                (prod. elxnce)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/disconnect" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-zoVEhPkYlILoJdtX-9dmwtQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>disconnect</strong><br/>
                (prod. 6houl)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/saveus" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000673267591-36n1g7-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>save us (shooting stars)</strong><br/>
                (prod. @prodbartes)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/saveus" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000673267591-36n1g7-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>save us (shooting stars)</strong><br/>
                (prod. @prodbartes)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/playpoker" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000670413937-v8axzc-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Play Poker (feat. SEBii)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/starrynight" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000666490606-egj6op-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>starry night</strong><br/>
                (prod. curtains)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/ww3-freestyle" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000662253403-a161bf-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ww3 freestyle</strong><br/>
                (prod. reuel)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/reject?in=sadoutwest/sets/crying-in-the-mosh-pit-ep" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000660606865-hlu7kt-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>reject</strong><br/>
                (prod. suttee)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/decode?in=sadoutwest%2Fsets%2Fcrying-in-the-mosh-pit-ep" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000660606865-hlu7kt-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>decode</strong><br/>
                (prod. kuroime & sketchmyname)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/handlethat?in=sadoutwest/sets/crying-in-the-mosh-pit-ep" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000660606865-hlu7kt-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>handle that freestyle</strong><br/>
                (prod. 3t)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/cryinginthemoshpit?in=sadoutwest/sets/crying-in-the-mosh-pit-ep" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000660606865-hlu7kt-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>crying in the mosh pit</strong><br/>
                (prod. suttee)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/myself" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000657717517-nq2u87-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>myself (feat. omu)</strong><br/>
                (prod. kiryano)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/weight/99-feat-sadoutwest-prod-dj-khaleds-son" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000651430360-p05b1h-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>lucas2k - 99 (feat. rileylol)</strong><br/>
                (prod. DJ Khaled's Son)
              </p>
            </a>
          </div>  

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/revive" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000656638129-c5er0x-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>revive</strong><br/>
                (prod. kaktus)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/cantconversate" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-YAChzwvuaVa2JdMO-5Mg4rg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>can't conversate</strong><br/>
                (prod. chikyu)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/thisway" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000633939274-r27y7y-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>this way</strong><br/>
                (prod. snorkatje)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/solarsage/run-away-feat-sadoutwest" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000629028214-o9h4nn-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>SolarSage - Run Away (feat. rileylol)</strong>
              </p>
            </a>
          </div>  

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/options" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000657714865-cn2iqy-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>options (feat. Midwxst)</strong><br/>
                (prod. ericslake)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/weight/falling-2-feat-sadoutwest-prod-y-axis" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000613231057-imesvj-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>lucas2k - hello kitty (feat. playwithguns, rileylol, wristcry, yung krypto & 1ondon)</strong><br/>
                (prod. solsa)
              </p>
            </a>
          </div>  

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/likethis" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000611675014-qynrxi-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>like this</strong><br/>
                (prod. iceboi qa)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/weight/falling-2-feat-sadoutwest-prod-y-axis" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000590134970-n9lmk0-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>lucas2k - falling 2 (feat. rileylol)</strong><br/>
                (prod. y axis)
              </p>
            </a>
          </div>  

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/sadoutwest/wings" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000593138507-zk36kc-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>wings</strong><br/>
                (prod. iceboi qa)
              </p>
            </a>
          </div>   

        </div>
      </>
    );
  };
  export default RileylolAllReleasesStatic;